import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ProfilePage as UIProfilePage } from '@pisaka/ui';
import { useSubscription } from '../subscription/useSubscription';
import { SubscriptionContainer } from '../subscription/SubscriptionContainer';
import { AppStateTypes } from '../../store/appStateTypes';

export const ProfilePage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { user } = useSelector((state: AppStateTypes) => state.auth) || {};
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
  const {
    currentSubscription,
    hasSubscription,
    isLoading,
    fetchCurrentSubscription,
    cancelSubscription,
    tokensRemaining,
    tokensPurchased,
    tokensPlanName,
    tokensExpireAt,
  } = useSubscription();

  const handleCancelSubscription = async (subscriptionId: string) => {
    await cancelSubscription(subscriptionId);
  };

  const profileTexts = {
    accessDenied: t('profile.accessDenied'),
    accessDeniedMessage: t('profile.accessDeniedMessage'),
    defaultUserName: t('profile.defaultUserName'),
    profileSection: t('profile.profileSection'),
    nameLabel: t('profile.nameLabel'),
    emailLabel: t('profile.emailLabel'),
    notSet: t('profile.notSet'),
    subscriptionSection: t('profile.subscriptionSection'),
    subscriptionDescription: t('profile.subscriptionDescription'),
    activeStatus: t('profile.activeStatus'),
    inactiveStatus: t('profile.inactiveStatus'),
    includedFeatures: t('profile.includedFeatures'),
    noSubscription: t('profile.noSubscription'),
    noSubscriptionHint: t('profile.noSubscriptionHint'),
    getSubscriptionLink: t('profile.getSubscriptionLink'),
    confirmCancel: t('profile.confirmCancel'),
    dateLocale: i18n.language.startsWith('en') ? 'en-US' : 'ru-RU',
    featureLabels: {
      recognition_photo: t('pricing.featureLabels.recognition_photo'),
      recognition_document: t('pricing.featureLabels.recognition_document'),
      recognition_youtube: t('pricing.featureLabels.recognition_youtube'),
      pdf_export: t('pricing.featureLabels.pdf_export'),
      double_page: t('pricing.featureLabels.double_page'),
      no_ads: t('pricing.featureLabels.no_ads'),
    },
    tokensSection: t('profile.tokensSection'),
    tokensRemaining: t('profile.tokensRemaining'),
    tokensPurchasedLabel: t('profile.tokensPurchasedLabel'),
    tokensExpire: t('profile.tokensExpire'),
    noTokens: t('profile.noTokens'),
  };

  return (
    <>
      <UIProfilePage
        user={user}
        currentSubscription={currentSubscription}
        hasSubscription={hasSubscription}
        isLoading={isLoading}
        onFetchCurrentSubscription={fetchCurrentSubscription}
        onCancelSubscription={handleCancelSubscription}
        onSubscribe={() => setIsSubscriptionModalOpen(true)}
        texts={profileTexts}
        tokensRemaining={tokensRemaining}
        tokensPurchased={tokensPurchased}
        tokensPlanName={tokensPlanName}
        tokensExpireAt={tokensExpireAt}
      />
      <SubscriptionContainer
        isOpen={isSubscriptionModalOpen}
        onClose={() => setIsSubscriptionModalOpen(false)}
        onSuccess={() => setIsSubscriptionModalOpen(false)}
      />
    </>
  );
};
